import { gql } from "@apollo/client";

export const ANSWER_CUSTOM_FIELDS_MUTATION = gql`
  mutation AnswerCustomFields($projectId: String!, $reponses: [CustomFieldResponseInputType!]!) {
    customFieldResponse {
      answerCustomFields(projectId: $projectId, reponses: $reponses)
    }
  }
`;